import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {UtilsService} from '../../../../core/utils/utils.service';
import {Auth2Service} from '../../../../core/services/security/auth2.service';
import {ActivatedRoute} from '@angular/router';
import ConditionnementVarianteDTO from '../../../../core/dtos/conditionnement/conditionnement-variante-dto';
import ConditionnementVarianteDeclinaisonDTO
  from '../../../../core/dtos/conditionnement/conditionnement-variante-declinaison-dto';
import ModeleConditionnementPlatDeclinaisonDTO
  from '../../../../core/dtos/conditionnement/modele-conditionnement-plat-declinaison-dto';
import {DialogMsgSupplier, Paragraphe} from '../../../../core/suppliers/dialog-msg-supplier';
import ModeleConditionnementsPlatConditionnementsVariantesDTO
  from '../../../../core/dtos/conditionnement/modele-conditionnement-plat-conditionnement-variante-dto';
import {TachesService} from '../../../../core/services/entities/taches.service';
import {TacheDTO} from '../../../../core/dtos/tache-dto';
import {TYPE_TACHE} from '../../../../core/services/entities/type-tache.service';
import {DeclinaisonDTO} from '../../../../core/dtos/declinaison-dto';
import ResteDTO from '../../../../core/dtos/conditionnement/reste-dto';
import {RestesService} from '../../../../core/services/conditionnements/restes.service';
import {cloneDeep as _cloneDeep} from 'lodash';
import {
  ModelePlatParametrage,
  ModelesPlatsService
} from '../../../../core/services/conditionnements/modeles-plats.service';
import {HELP_FOLDERS, MSG_KEY, MSG_SEVERITY} from '../../../../core/constants';
import {ToastService} from "../../../../core/services/technique/toast.service";
import {ListComponent} from "../../../../shared/ui/list/list.component";
import {ButtonThemeEnum} from "../../../../shared/ui/button/button-theme-enum";

@Component({
    selector: 'yo-mp-parametrage',
    templateUrl: './mp-parametrage.component.html',
    styleUrls: ['./mp-parametrage.component.scss'],
    standalone: false
})
export class ParametrageConditionnementModelesPlatsComponent implements OnInit, OnDestroy {

  subSupplier: Subscription;

  @ViewChild("list") list: ListComponent;

  conditionnementVariantesList: ConditionnementVarianteDTO[];
  conditionnementVariantesDeclinaisonsList: ConditionnementVarianteDeclinaisonDTO[];
  modelesConditionnementsPlatDeclinaisonsList: ModeleConditionnementPlatDeclinaisonDTO[];
  mcpConditionnementVarianteList: ModeleConditionnementsPlatConditionnementsVariantesDTO[];

  /**
   * Totalité des déclinaisons
   */
  declinaisonList: DeclinaisonDTO[] = [];

  /**
   * Gestion des queues
   */
  queuesConfiguration: any = {};

  /**
   * Totalité des restes
   */
  resteList: ResteDTO[];

  /**
   *  Un trompe oeil pour DevExtreme pour avoir 1 footer d'une seule ligne.
   */
  footerList: any[] = [{id: 1}];

  /**
   * Mapping entre le n° de colonne DevExtreme et l'identifiant d'une déclinaison
   */
  mappingColumnsDeclinaisons: Map<number, number> = new Map<number, number>();

  /**
   * Totalité des tâches
   */
  tachesList: TacheDTO[];

  gridParametrage: any[];

  hasIDistri = false;

  idMcp: number;
  mode: string;
  uniteAConditionnerLibelle: string;

  declinaisonsNbUCList: any[] = [];

  displayDuplicationDialog: boolean = false;
  selectedDeclinaisonDialog: number;
  declinaisonDialogList: DeclinaisonDTO[] = [];
  selectedDeclinaisonDialogList: DeclinaisonDTO[] = [];

  pathFile: string = HELP_FOLDERS.CONDITIONNEMENT + '/conditionnement-modeles-plats-parametrage';

  constructor(public utils: UtilsService,
              public auth2Svc: Auth2Service,
              private route: ActivatedRoute,
              private resteSvc: RestesService,
              private tacheSvc: TachesService,
              private mpcSvc: ModelesPlatsService,
              private toastSvc: ToastService) {
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subSupplier);
  }

  ngOnInit(): void {
    this.initDataFromSupplierSubscription();
    this.initHasGestionIDistri();
  }

  openCreateRowParametrage = (): void => {
    this.mpcSvc.announceCreationRowParametrageAsked();
  };

  initHasGestionIDistri = (): void => {
    this.auth2Svc.hasGestionIDistri$.subscribe(response => this.hasIDistri = response);
  };

  initDataFromSupplierSubscription = () => {
    this.subSupplier = this.route.parent.data
      .subscribe((data: any) => {
        if (data.modelePlatSupplier) {
          this.conditionnementVariantesList = data.modelePlatSupplier.conditionnementVarianteList;
          this.conditionnementVariantesDeclinaisonsList = data.modelePlatSupplier.conditionnementVarianteDeclinaisonList;
          this.modelesConditionnementsPlatDeclinaisonsList = data.modelePlatSupplier.mcpDeclinaisonList;
          this.mcpConditionnementVarianteList = data.modelePlatSupplier.mcpConditionnementVarianteList;
          this.idMcp = data.modelePlatSupplier.idModeleConditionnementPlat;
          this.mode = data.modelePlatSupplier.modelePlatConditionnement.mode;
          this.uniteAConditionnerLibelle = `${data.modelePlatSupplier.modelePlatConditionnement.uniteAConditionner?.libelle}(s)`;

          if (this.modelesConditionnementsPlatDeclinaisonsList) {
            this.declinaisonList = this.modelesConditionnementsPlatDeclinaisonsList.map(mcpd => mcpd.declinaison)
              .sort((a, b) => a.libelle.localeCompare(b.libelle));
            this.declinaisonsNbUCList = this.modelesConditionnementsPlatDeclinaisonsList.map(m => ({declinaison: m.declinaison, nbUc: m.nbUc}));
          }

          this.initQueuesConfiguration();
          this.initRestes();
          this.initTaches();
          this.initGridParametrage();
        }
      });
  };

  changeQueue = ($event, columnIndex) => {
    if (this.queuesConfiguration[columnIndex]) {
      this.queuesConfiguration[columnIndex].reste = this.resteList.find(r => r.id === $event.value);
    }
  };

  changeNbUc = ($event, cell, changedManually: boolean = false): void => {
    if (changedManually) {
      const value = this.checkNbUcValue($event.value);

      const columnIdx = cell.columnIndex;
      this.declinaisonsNbUCList[columnIdx].nbUc = value;

      this.gridParametrage.forEach(item => {
        if (item.declinaisons[columnIdx + 2].id === this.declinaisonsNbUCList[columnIdx].id)
          item.declinaisons[columnIdx + 2][item.id].contient = value * item.declinaisons[columnIdx + 2][item.id].effectifNourri;
      })

      if (value == $event.previousValue)
        $event.component.reset();
    }
  };

  private checkNbUcValue = value => {
    if (!value || value == 0)
      return 1;
    return value;
  };

  changeEffectif = ($event, cell, changedManually: boolean = false): void => {
    if (changedManually) {
      const value = $event.value;
      const columnIdx = cell.columnIndex;
      const key = cell.key;

      this.gridParametrage.forEach(item => {
        if (item.id === key) {
          item.declinaisons[columnIdx][key].effectifNourri = value;
          if (this.mode === 'PIECE_NON_PROPORTIONNELLE') item.declinaisons[columnIdx][key].contient = value * this.declinaisonsNbUCList[columnIdx - 2].nbUc;
        }
      });
    }
  }

  onFocusIn = (e: any) => {
    let inputEl = e.element.querySelector(".dx-texteditor-input");
    inputEl.selectionStart = 0;
    inputEl.selectionEnd = inputEl.value.length;
  };

  private initQueuesConfiguration = () => {
    if (this.modelesConditionnementsPlatDeclinaisonsList.sort((a, b) => a.declinaison.libelle.localeCompare(b.declinaison.libelle))) {
      this.modelesConditionnementsPlatDeclinaisonsList.forEach((mcpd, idx) => {
        // le mapping entre l'index et la déclinaison ID est expliquée plus bas (ligne 111) :
        this.queuesConfiguration[idx + 2] = {reste: mcpd.reste, idmcpd: mcpd.id, idDeclinaison: mcpd.declinaison.id}
      });
    }
  };

  private initRestes = () => {
    this.resteSvc.getAll()
      .subscribe(restes => this.resteList = restes.resultList);
  };

  private initTaches = () => {
    this.tacheSvc.getAll()
      .subscribe(taches => {
        this.tachesList = this.tacheSvc.filterByTypeTache(taches.resultList, TYPE_TACHE.CONDITIONNEMENT);
      });
  };

  private initGridParametrage = () => {
    if (this.conditionnementVariantesList) {
      this.gridParametrage = this.conditionnementVariantesList.map(cv => {
        const current = this.mcpConditionnementVarianteList.find((m: ModeleConditionnementsPlatConditionnementsVariantesDTO) => {
          return m.conditionnementVariante && m.conditionnementVariante.id === cv.id
        });

        const declinaisons = {};

        this.declinaisonList = this.declinaisonList.filter(declinaison => this.conditionnementVariantesDeclinaisonsList.find((cvd: ConditionnementVarianteDeclinaisonDTO) =>
          cvd.modeleConditionnementsPlat__variantes__conditionnements &&
          cvd.modeleConditionnementsPlat__variantes__conditionnements.conditionnementVariante &&
          cvd.modeleConditionnementsPlat__variantes__conditionnements.conditionnementVariante.id === cv.id &&
          cvd.modeleConditionnementPlat__declinaison.declinaison &&
          cvd.modeleConditionnementPlat__declinaison.declinaison.id === declinaison.id));

        this.declinaisonList.forEach((declinaison, idx) => {
          const currentCvd = this.conditionnementVariantesDeclinaisonsList.find((cvd: ConditionnementVarianteDeclinaisonDTO) =>
            cvd.modeleConditionnementsPlat__variantes__conditionnements &&
            cvd.modeleConditionnementsPlat__variantes__conditionnements.conditionnementVariante &&
            cvd.modeleConditionnementsPlat__variantes__conditionnements.conditionnementVariante.id === cv.id &&
            cvd.modeleConditionnementPlat__declinaison.declinaison &&
            cvd.modeleConditionnementPlat__declinaison.declinaison.id === declinaison.id
          );

          // + 2 car les premières colonnes sont conditionnement et variante :
          if (currentCvd) {
            const key = idx + 2;
            this.mappingColumnsDeclinaisons.set(key, declinaison.id);
            // declinaison => objet dont la clé est l'association de l'identifiant d'une condition variante et d'une déclinaison.
            // En effet, chaque valeur prescrite dans une cellule est faite pour une déclinaison d'une condition variante.
            declinaisons[key] = {
              [cv.id]: { // identifiant pour représenter la ligne de l'ihm
                id: declinaison.id,
                mcp__did: currentCvd.modeleConditionnementPlat__declinaison.id,
                mcp__cvid: currentCvd.modeleConditionnementsPlat__variantes__conditionnements.id,
                cvdid: currentCvd.id, // Identifiant à utiliser pour le backend
                contient: currentCvd ? currentCvd.contient : 0.0,
                effectifNourri: currentCvd ? currentCvd.effectifNourri : 0.0,
                poidsNet: currentCvd ? currentCvd.poidsNet : 0.0,
                uniteAConditionner: currentCvd && currentCvd.modeleConditionnementPlat__declinaison && currentCvd.modeleConditionnementPlat__declinaison.modeleConditionnementPlat && currentCvd.modeleConditionnementPlat__declinaison.modeleConditionnementPlat.uniteAConditionner.abreviation ? currentCvd.modeleConditionnementPlat__declinaison.modeleConditionnementPlat.uniteAConditionner.abreviation : 'POR',
              }
            }
          }
        });

        const result = {
          id: cv.id,
          conditionnementLabel: cv.conditionnement ? cv.conditionnement.libelle : '',
          varianteLabel: cv.variante ? cv.variante.libelle : 'Aucune',
          remarque: current && current.remarque ? current.remarque : '',
          idtache: current && current.tache ? current.tache.id : null,
          idmcpcv: current.id,
          declinaisons
        };

        return (result);
      });

      this.gridParametrage = [...new Set(this.gridParametrage.map(g => g.id))].map(id => this.gridParametrage.find(a => a.id === id));
    }
  };

  /**
   * Enregistre les valeurs paramétrées de la grille.
   */
  save = (): void => {
    // Préparation de l'objet à envoyer au back-end :
    const grid = _cloneDeep(this.gridParametrage);
    let data: ModelePlatParametrage = this.mpcSvc.formatDataParametrage(grid, this.mappingColumnsDeclinaisons, this.idMcp, this.mode, this.queuesConfiguration);

    this.mpcSvc.saveNombresUnitesAServir(this.idMcp, this.declinaisonsNbUCList)
      .subscribe((result) => {
        if (!result.error)
          this.mpcSvc.saveParametrage(data)
            .subscribe(() => {
              this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Paramétrage réalisé avec succès`);
            });
      });
  };

  public help(): DialogMsgSupplier {
    const dms = new DialogMsgSupplier();
    dms.title = `Paramétrage des modèles de plats`;
    dms.logo = 'fa fa-question-circle  yoni-color';
    const p1: Paragraphe = new Paragraphe();
    p1.title = ``;
    p1.lines = [];

    dms.content = {
      intro: ``,
      paragraphes: []
    };

    return dms;
  }

  openDuclicationPopup = () => {
    this.displayDuplicationDialog = true;
    this.declinaisonDialogList = this.declinaisonList;
  };

  closeDuplicationDialog = () => {
    this.displayDuplicationDialog = false;
    this.selectedDeclinaisonDialog = undefined;
    this.declinaisonDialogList = [];
    this.selectedDeclinaisonDialogList = [];
  };

  onDeclinaisonSelected = (declinaison: any) => {
    this.selectedDeclinaisonDialog = declinaison;
    this.declinaisonDialogList = this.declinaisonList.filter(decli => decli.id != declinaison);
  };

  onDeclinaisonSelectionChange = (data) => {
    this.selectedDeclinaisonDialogList = data;
  };

  updateDeclinaisons = () => {

    let selectedIndex = this.declinaisonList.findIndex(decli => decli.id == this.selectedDeclinaisonDialog) + 2;

    this.selectedDeclinaisonDialogList.forEach(declinaison => {
      let columnId = this.declinaisonList.findIndex(decli => decli.id == declinaison.id) + 2;
      this.queuesConfiguration[columnId].reste = this.queuesConfiguration[selectedIndex].reste;

      this.gridParametrage.forEach((ligne, key) => {
          let reference = ligne.declinaisons[selectedIndex][ligne.id];
          let value = ligne.declinaisons[columnId][ligne.id];

          if (this.mode === 'PIECE_NON_PROPORTIONNELLE')
            value.contient = reference.effectifNourri * this.declinaisonsNbUCList[columnId - 2].nbUc;
          else
            value.contient = reference.contient;
          value.effectifNourri = reference.effectifNourri;
          value.poidsNet = reference.poidsNet;
        }
      )
    })

    this.closeDuplicationDialog();
  }

  isSaveDialogEnabled = () => {
    return this.selectedDeclinaisonDialog && this.selectedDeclinaisonDialogList && this.selectedDeclinaisonDialogList.length > 0;
  };
  public readonly ButtonThemeEnum = ButtonThemeEnum;
}
